module.exports = __webpack_public_path__ + "img/multi_family.d307c99c.svg";